var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-sidebar__block--external-message"},[_c('vb-icon',{attrs:{"name":'exclamation',"color":_vm.sass('danger'),"size":24}}),_c('div',{staticClass:"external-message--text mt-2",domProps:{"innerHTML":_vm._s(_vm.external_condition.sidebar_message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }